/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateAddressData } from './UpdateAddressData';
import {
    UpdateAddressDataFromJSON,
    UpdateAddressDataFromJSONTyped,
    UpdateAddressDataToJSON,
    UpdateAddressDataToJSONTyped,
} from './UpdateAddressData';

/**
 * Represents 3rd party customer information related to billing for a company
 * @export
 * @interface UpdateBillingDetailsData
 */
export interface UpdateBillingDetailsData {
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingDetailsData
     */
    name?: string;
    /**
     * 
     * @type {UpdateAddressData}
     * @memberof UpdateBillingDetailsData
     */
    address?: UpdateAddressData;
}

/**
 * Check if a given object implements the UpdateBillingDetailsData interface.
 */
export function instanceOfUpdateBillingDetailsData(value: object): value is UpdateBillingDetailsData {
    return true;
}

export function UpdateBillingDetailsDataFromJSON(json: any): UpdateBillingDetailsData {
    return UpdateBillingDetailsDataFromJSONTyped(json, false);
}

export function UpdateBillingDetailsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingDetailsData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : UpdateAddressDataFromJSON(json['address']),
    };
}

  export function UpdateBillingDetailsDataToJSON(json: any): UpdateBillingDetailsData {
      return UpdateBillingDetailsDataToJSONTyped(json, false);
  }

  export function UpdateBillingDetailsDataToJSONTyped(value?: UpdateBillingDetailsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': UpdateAddressDataToJSON(value['address']),
    };
}

